import { MenuItem } from "@material-ui/core";
import { useState } from "react";

const ModalMenuItem = ({
  title,
  Component,
  onBeforeOpen = () => true,
}: {
  title: string;
  Component: any;
  onBeforeOpen?: () => boolean;
}) => {
  const [open, setOpen] = useState(false);

  const handleClickItem = () => {
    if (onBeforeOpen()) setOpen(true);
  };

  return (
    <>
      <MenuItem onClick={handleClickItem}>{title}</MenuItem>
      <Component open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ModalMenuItem;
